@if (showEnableFeature) {
  <div class="row button-container">
    <div class="col-2 custom-button">
      <div class="rSet enable-alo-label">
        <label aria-hidden="true">
          Enable feature
          <input type="checkbox" class="primary-checkbox" name="enableFeature"
            [(ngModel)]="isEnableFeature" (change)="onEnabledCheckboxChange($event)" />
          <span class="extra-border-enablefeat" id="DSC-enable-feature" role="checkbox" aria-checked="false" [attr.aria-checked]="isEnableFeature"></span>
        </label>
      </div>
    </div>
    <div class="col-8"></div>
    <div class="col-1"></div>
  </div>
}

<!-- Presence Level -->
<div class="row slider-container activedim-margin" [ngClass]="{'isResetDisabled': dscDisabled && showEnableFeature}">
	<div class="col-1 label label-wrap signifyBookmd dim-margin" id="DSC-presence-level-label">Presence level</div>
		@if (quickConfigvalue) {
			<div class="col-2">
				<div class="row">
					<div class="col-4"></div>
					<div class="col-2 minValMargin">
						<span class="signifyBookmd minValue" id="DSC-presence-level-STDmin" [ngClass]="{'isResetDisabled': presenceLevelUseDynadimmer}"> min {{ presenceLevelMin }}</span>
					</div>
					<div class="col-3">
						<span class="signifyBookmd maxValue" id="DSC-presence-level-STDmax" [ngClass]="{'isResetDisabled': presenceLevelUseDynadimmer}"> max {{ presenceLevelMax }}</span>
					</div>
				</div>
			</div>
		}
		@if (!quickConfigvalue) {
			<span class="signifyBookmd text-mindim sliderMinValue col-1" id="DSC-presence-level-min" [ngClass]="{'isResetDisabled': presenceLevelUseDynadimmer}">{{ presenceLevelMin }}</span>
		}
		@if (!quickConfigvalue) {
			<div class="col-6 curvePadding sliderCss" id="DSC-presence-level-slider" [ngClass]="{'isSliderClick': (dscDisabled && showEnableFeature) || presenceLevelUseDynadimmer, 'isResetDisabled': (dscDisabled && showEnableFeature) || presenceLevelUseDynadimmer}">
				<ngx-slider
					type="normalType"
					ngDefaultControl
					id="DSC-presence-level-range"
					[value]="getSliderSafeValue(presenceLevel, presenceLevelMin, presenceLevelMax)"
					[options]="presenceLevelOptions"
					[disabled]="presenceLevelUseDynadimmer"
					(userChangeEnd)="onSliderChange($any($event).value, 'presenceLevel')"
				>
				</ngx-slider>
			</div>
		}
		@if (!quickConfigvalue) {
			<span class="signifyBookmd text-mindim col-1 startUpMargin" id="DSC-presence-level-max" [ngClass]="{'isResetDisabled': presenceLevelUseDynadimmer}">{{ presenceLevelMax }}</span>
		}
		<div class="row form-group col-3">
			<input
				type="number"
				[value]="presenceLevelUseDynadimmer ? '' : presenceLevelDisplay"
				class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
				[ngClass]="{'myStyle': inputError['presenceLevel'], 'isResetDisabled custom-inputbox-disabled': presenceLevelUseDynadimmer, 'inputCssStandard': quickConfigvalue === true}"
				[disabled]="presenceLevelUseDynadimmer || (dscDisabled && showEnableFeature)"
				(keypress)="numberOnly($event)"
				(input)="onFieldInput($any($event.target).value, 'presenceLevel')"
				(blur)="onFieldBlur($any($event.target), 'presenceLevel')"
				id="DSC-presence-level-input"
			/>
			<p class="signifyBookmd" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</p>
		</div>
	</div>

	<!-- Presence Level Use Dynadimmer Checkbox -->
	@if (presenceLevelHasDynadimmer) {
		<div class="row slider-container checkbox-indent" [ngClass]="{'isResetDisabled': dscDisabled && showEnableFeature}">
			<div class="col-1"></div>
			<div class="col-10 checkbox-indent-small-screen">
				<label class="checkbox-label" for="DSC-presence-dynadimmer">
					<input
						type="checkbox"
						class="primary-checkbox"
						[checked]="presenceLevelUseDynadimmer"
						(change)="onDynadimmerCheckboxChange($event, 'presence')"
						[disabled]="dscDisabled && showEnableFeature"
						id="DSC-presence-dynadimmer"
					/>
					<span class="extra-border-enablefeat" id="DSC-presence-dynadimmer-checkbox"></span>
					<span class="signifyBookmd checkbox-text">Use Dynadimmer level</span>
				</label>
			</div>
		</div>
	}

	<!-- Presence Fade Time -->
	<div class="row slider-container" [ngClass]="{'isResetDisabled': dscDisabled && showEnableFeature}">
		<div class="col-1 label label-wrap signifyBookmd dim-margin" id="DSC-presence-fade-label">Presence fade time</div>
		@if (quickConfigvalue) {
			<div class="col-2">
				<div class="row">
					<div class="col-4"></div>
					<div class="col-2 minValMargin">
						<span class="signifyBookmd minValue" id="DSC-presence-fade-STDmin"> min {{ presenceFadeTimeMin }}</span>
					</div>
					<div class="col-3">
						<span class="signifyBookmd maxValue" id="DSC-presence-fade-STDmax"> max {{ presenceFadeTimeMax }}</span>
					</div>
				</div>
			</div>
		}
		@if (!quickConfigvalue) {
			<span class="signifyBookmd text-mindim sliderMinValue col-1" id="DSC-presence-fade-min">{{ presenceFadeTimeMin }}</span>
		}
		@if (!quickConfigvalue) {
			<div class="col-6 curvePadding sliderCss" id="DSC-presence-fade-slider" [ngClass]="{'isSliderClick': dscDisabled && showEnableFeature}">
				<ngx-slider
					type="normalType"
					ngDefaultControl
					id="DSC-presence-fade-range"
					[value]="getSliderSafeValue(presenceFadeTime, presenceFadeTimeMin, presenceFadeTimeMax)"
					[options]="presenceFadeTimeOptions"
					(userChangeEnd)="onSliderChange($any($event).value, 'presenceFadeTime')"
				>
				</ngx-slider>
			</div>
		}
		@if (!quickConfigvalue) {
			<span class="signifyBookmd text-mindim col-1 startUpMargin" id="DSC-presence-fade-max">{{ presenceFadeTimeMax }}</span>
		}
		<div class="row form-group col-3">
			<input
				type="number"
				[value]="presenceFadeTimeDisplay"
				class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
				[ngClass]="{'myStyle': inputError['presenceFadeTime'], 'inputCssStandard': quickConfigvalue === true}"
				[disabled]="dscDisabled && showEnableFeature"
				(keypress)="numberOnly($event)"
				(input)="onFieldInput($any($event.target).value, 'presenceFadeTime')"
				(blur)="onFieldBlur($any($event.target), 'presenceFadeTime')"
				id="DSC-presence-fade-input"
			/>
			<p class="signifyBookmd" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">sec</p>
		</div>
	</div>

	<!-- Presence Hold Time -->
	<div class="row slider-container" [ngClass]="{'isResetDisabled': dscDisabled && showEnableFeature}">
		<div class="col-1 label label-wrap signifyBookmd dim-margin" id="DSC-presence-hold-label">Presence hold time</div>
		@if (quickConfigvalue) {
			<div class="col-2">
				<div class="row">
					<div class="col-4"></div>
					<div class="col-2 minValMargin">
						<span class="signifyBookmd minValue" id="DSC-presence-hold-STDmin" [ngClass]="{'isResetDisabled': presenceHoldTimeInfinite}"> min {{ presenceHoldTimeMin }}</span>
					</div>
					<div class="col-3">
						<span class="signifyBookmd maxValue" id="DSC-presence-hold-STDmax" [ngClass]="{'isResetDisabled': presenceHoldTimeInfinite}"> max {{ presenceHoldTimeMax }}</span>
					</div>
				</div>
			</div>
		}
		@if (!quickConfigvalue) {
			<span class="signifyBookmd text-mindim sliderMinValue col-1" id="DSC-presence-hold-min" [ngClass]="{'isResetDisabled': presenceHoldTimeInfinite}">{{ presenceHoldTimeMin }}</span>
		}
		@if (!quickConfigvalue) {
			<div class="col-6 curvePadding sliderCss" id="DSC-presence-hold-slider" [ngClass]="{'isSliderClick': (dscDisabled && showEnableFeature) || presenceHoldTimeInfinite, 'isResetDisabled': (dscDisabled && showEnableFeature) || presenceHoldTimeInfinite}">
				<ngx-slider
					type="normalType"
					ngDefaultControl
					id="DSC-presence-hold-range"
					[value]="getSliderSafeValue(presenceHoldTime, presenceHoldTimeMin, presenceHoldTimeMax)"
					[options]="presenceHoldTimeOptions"
					[disabled]="presenceHoldTimeInfinite"
					(userChangeEnd)="onSliderChange($any($event).value, 'presenceHoldTime')"
				>
				</ngx-slider>
			</div>
		}
		@if (!quickConfigvalue) {
			<span class="signifyBookmd text-mindim col-1 startUpMargin" id="DSC-presence-hold-max" [ngClass]="{'isResetDisabled': presenceHoldTimeInfinite}">{{ presenceHoldTimeMax }}</span>
		}
		<div class="row form-group col-3">
			<input
				type="number"
				[value]="presenceHoldTimeInfinite ? '' : presenceHoldTimeDisplay"
				class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
				[ngClass]="{'myStyle': inputError['presenceHoldTime'], 'isResetDisabled custom-inputbox-disabled': presenceHoldTimeInfinite, 'inputCssStandard': quickConfigvalue === true}"
				[disabled]="presenceHoldTimeInfinite || (dscDisabled && showEnableFeature)"
				(keypress)="numberOnly($event)"
				(input)="onFieldInput($any($event.target).value, 'presenceHoldTime')"
				(blur)="onFieldBlur($any($event.target), 'presenceHoldTime')"
				id="DSC-presence-hold-input"
			/>
			<p class="signifyBookmd" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">sec</p>
		</div>
	</div>

	<!-- Presence Hold Time Infinite Checkbox -->
	<div class="row slider-container checkbox-indent" [ngClass]="{'isResetDisabled': dscDisabled && showEnableFeature}">
		<div class="col-1"></div>
		<div class="col-10 checkbox-indent-small-screen">
			<label class="checkbox-label" for="DSC-presence-infinite">
				<input
					type="checkbox"
					class="primary-checkbox"
					[checked]="presenceHoldTimeInfinite"
					(change)="onInfiniteCheckboxChange($event, 'presence')"
					[disabled]="dscDisabled && showEnableFeature"
					id="DSC-presence-infinite"
				/>
				<span class="extra-border-enablefeat" id="DSC-presence-infinite-checkbox"></span>
				<span class="signifyBookmd checkbox-text">Infinite</span>
			</label>
		</div>
	</div>

	<!-- No Presence Level -->
	<div class="row slider-container" [ngClass]="{'isResetDisabled': dscDisabled && showEnableFeature}">
		<div class="col-1 label label-wrap signifyBookmd dim-margin" id="DSC-no-presence-level-label">No presence level</div>
		@if (quickConfigvalue) {
			<div class="col-2">
				<div class="row">
					<div class="col-4"></div>
					<div class="col-2 minValMargin">
					<span class="signifyBookmd minValue" id="DSC-no-presence-level-STDmin" [ngClass]="{'isResetDisabled': noPresenceLevelUseDynadimmer}"> min {{ noPresenceLevelMin }}</span>
				</div>
				<div class="col-3">
					<span class="signifyBookmd maxValue" id="DSC-no-presence-level-STDmax" [ngClass]="{'isResetDisabled': noPresenceLevelUseDynadimmer}"> max {{ noPresenceLevelMax }}</span>
					</div>
				</div>
			</div>
		}
		@if (!quickConfigvalue) {
			<span class="signifyBookmd text-mindim sliderMinValue col-1" id="DSC-no-presence-level-min" [ngClass]="{'isResetDisabled': noPresenceLevelUseDynadimmer}">{{ noPresenceLevelMin }}</span>
		}
		@if (!quickConfigvalue) {
			<div class="col-6 curvePadding sliderCss" id="DSC-no-presence-level-slider" [ngClass]="{'isSliderClick': (dscDisabled && showEnableFeature) || noPresenceLevelUseDynadimmer, 'isResetDisabled': (dscDisabled && showEnableFeature) || noPresenceLevelUseDynadimmer}">
				<ngx-slider
					type="normalType"
					ngDefaultControl
					id="DSC-no-presence-level-range"
					[value]="getSliderSafeValue(noPresenceLevel, noPresenceLevelMin, noPresenceLevelMax)"
					[options]="noPresenceLevelOptions"
					[disabled]="noPresenceLevelUseDynadimmer"
					(userChangeEnd)="onSliderChange($any($event).value, 'noPresenceLevel')"
				>
				</ngx-slider>
			</div>
		}
		@if (!quickConfigvalue) {
			<span class="signifyBookmd text-mindim col-1 startUpMargin" id="DSC-no-presence-level-max" [ngClass]="{'isResetDisabled': noPresenceLevelUseDynadimmer}">{{ noPresenceLevelMax }}</span>
		}
		<div class="row form-group col-3">
			<input
				type="number"
				[value]="noPresenceLevelUseDynadimmer ? '' : noPresenceLevelDisplay"
				class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
				[ngClass]="{'myStyle': inputError['noPresenceLevel'], 'isResetDisabled custom-inputbox-disabled': noPresenceLevelUseDynadimmer, 'inputCssStandard': quickConfigvalue === true}"
				[disabled]="noPresenceLevelUseDynadimmer || (dscDisabled && showEnableFeature)"
				(keypress)="numberOnly($event)"
				(input)="onFieldInput($any($event.target).value, 'noPresenceLevel')"
				(blur)="onFieldBlur($any($event.target), 'noPresenceLevel')"
				id="DSC-no-presence-level-input"
			/>
			<p class="signifyBookmd" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</p>
		</div>
	</div>

	<!-- No Presence Level Use Dynadimmer Checkbox -->
	@if (noPresenceLevelHasDynadimmer) {
		<div class="row slider-container checkbox-indent" [ngClass]="{'isResetDisabled': dscDisabled && showEnableFeature}">
			<div class="col-1"></div>
			<div class="col-10 checkbox-indent-small-screen">
				<label class="checkbox-label" for="DSC-no-presence-dynadimmer">
					<input
						type="checkbox"
						class="primary-checkbox"
						[checked]="noPresenceLevelUseDynadimmer"
						(change)="onDynadimmerCheckboxChange($event, 'noPresence')"
						[disabled]="dscDisabled && showEnableFeature"
						id="DSC-no-presence-dynadimmer"
					/>
					<span class="extra-border-enablefeat" id="DSC-no-presence-dynadimmer-checkbox"></span>
					<span class="signifyBookmd checkbox-text">Use Dynadimmer level</span>
				</label>
			</div>
		</div>
	}

	<!-- No Presence Fade Time -->
	<div class="row slider-container" [ngClass]="{'isResetDisabled': dscDisabled && showEnableFeature}">
		<div class="col-1 label label-wrap signifyBookmd dim-margin" id="DSC-no-presence-fade-label">No presence fade time</div>
		@if (quickConfigvalue) {
			<div class="col-2">
				<div class="row">
					<div class="col-4"></div>
					<div class="col-2 minValMargin">
						<span class="signifyBookmd minValue" id="DSC-no-presence-fade-STDmin"> min {{ noPresenceFadeTimeMin }}</span>
					</div>
					<div class="col-3">
						<span class="signifyBookmd maxValue" id="DSC-no-presence-fade-STDmax"> max {{ noPresenceFadeTimeMax }}</span>
					</div>
				</div>
			</div>
		}
		@if (!quickConfigvalue) {
			<span class="signifyBookmd text-mindim sliderMinValue col-1" id="DSC-no-presence-fade-min">{{ noPresenceFadeTimeMin }}</span>
		}
		@if (!quickConfigvalue) {
			<div class="col-6 curvePadding sliderCss" id="DSC-no-presence-fade-slider" [ngClass]="{'isSliderClick': dscDisabled && showEnableFeature}">
				<ngx-slider
					type="normalType"
					ngDefaultControl
					id="DSC-no-presence-fade-range"
					[value]="getSliderSafeValue(noPresenceFadeTime, noPresenceFadeTimeMin, noPresenceFadeTimeMax)"
					[options]="noPresenceFadeTimeOptions"
					(userChangeEnd)="onSliderChange($any($event).value, 'noPresenceFadeTime')"
				>
				</ngx-slider>
			</div>
		}
		@if (!quickConfigvalue) {
			<span class="signifyBookmd text-mindim col-1 startUpMargin" id="DSC-no-presence-fade-max">{{ noPresenceFadeTimeMax }}</span>
		}
		<div class="row form-group col-3">
			<input
				type="number"
				[value]="noPresenceFadeTimeDisplay"
				class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
				[ngClass]="{'myStyle': inputError['noPresenceFadeTime'], 'inputCssStandard': quickConfigvalue === true}"
				[disabled]="dscDisabled && showEnableFeature"
				(keypress)="numberOnly($event)"
				(input)="onFieldInput($any($event.target).value, 'noPresenceFadeTime')"
				(blur)="onFieldBlur($any($event.target), 'noPresenceFadeTime')"
				id="DSC-no-presence-fade-input"
			/>
			<p class="signifyBookmd" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">sec</p>
		</div>
	</div>

	<!-- No Presence Prolong Time -->
	<div class="row slider-container" [ngClass]="{'isResetDisabled': dscDisabled && showEnableFeature}">
		<div class="col-1 label label-wrap signifyBookmd dim-margin" id="DSC-no-presence-prolong-label">No presence prolong time</div>
		@if (quickConfigvalue) {
			<div class="col-2">
				<div class="row">
					<div class="col-4"></div>
					<div class="col-2 minValMargin">
					<span class="signifyBookmd minValue" id="DSC-no-presence-prolong-STDmin" [ngClass]="{'isResetDisabled': noPresenceProlongTimeInfinite}"> min {{ noPresenceProlongTimeMin }}</span>
				</div>
				<div class="col-3">
					<span class="signifyBookmd maxValue" id="DSC-no-presence-prolong-STDmax" [ngClass]="{'isResetDisabled': noPresenceProlongTimeInfinite}"> max {{ noPresenceProlongTimeMax }}</span>
					</div>
				</div>
			</div>
		}
		@if (!quickConfigvalue) {
			<span class="signifyBookmd text-mindim sliderMinValue col-1" id="DSC-no-presence-prolong-min" [ngClass]="{'isResetDisabled': noPresenceProlongTimeInfinite}">{{ noPresenceProlongTimeMin }}</span>
		}
		@if (!quickConfigvalue) {
			<div class="col-6 curvePadding sliderCss" id="DSC-no-presence-prolong-slider" [ngClass]="{'isSliderClick': (dscDisabled && showEnableFeature) || noPresenceProlongTimeInfinite, 'isResetDisabled': (dscDisabled && showEnableFeature) || noPresenceProlongTimeInfinite}">
				<ngx-slider
					type="normalType"
					ngDefaultControl
					id="DSC-no-presence-prolong-range"
					[value]="getSliderSafeValue(noPresenceProlongTime, noPresenceProlongTimeMin, noPresenceProlongTimeMax)"
					[options]="noPresenceProlongTimeOptions"
					[disabled]="noPresenceProlongTimeInfinite"
					(userChangeEnd)="onSliderChange($any($event).value, 'noPresenceProlongTime')"
				>
				</ngx-slider>
			</div>
		}
		@if (!quickConfigvalue) {
			<span class="signifyBookmd text-mindim col-1 startUpMargin" id="DSC-no-presence-prolong-max" [ngClass]="{'isResetDisabled': noPresenceProlongTimeInfinite}">{{ noPresenceProlongTimeMax }}</span>
		}
		<div class="row form-group col-3">
			<input
				type="number"
				[value]="noPresenceProlongTimeInfinite ? '' : noPresenceProlongTimeDisplay"
				class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
				[ngClass]="{'myStyle': inputError['noPresenceProlongTime'], 'isResetDisabled custom-inputbox-disabled': noPresenceProlongTimeInfinite, 'inputCssStandard': quickConfigvalue === true}"
				[disabled]="noPresenceProlongTimeInfinite || (dscDisabled && showEnableFeature)"
				(keypress)="numberOnly($event)"
				(input)="onFieldInput($any($event.target).value, 'noPresenceProlongTime')"
				(blur)="onFieldBlur($any($event.target), 'noPresenceProlongTime')"
				id="DSC-no-presence-prolong-input"
			/>
			<p class="signifyBookmd" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">sec</p>
		</div>
	</div>

	<!-- No Presence Prolong Time Infinite Checkbox -->
	<div class="row slider-container checkbox-indent" [ngClass]="{'isResetDisabled': dscDisabled && showEnableFeature}">
		<div class="col-1"></div>
		<div class="col-10 checkbox-indent-small-screen">
			<label class="checkbox-label" for="DSC-no-presence-infinite">
				<input
					type="checkbox"
					class="primary-checkbox"
					[checked]="noPresenceProlongTimeInfinite"
					(change)="onInfiniteCheckboxChange($event, 'noPresence')"
					[disabled]="dscDisabled && showEnableFeature"
					id="DSC-no-presence-infinite"
				/>
				<span class="extra-border-enablefeat" id="DSC-no-presence-infinite-checkbox"></span>
				<span class="signifyBookmd checkbox-text">Infinite</span>
			</label>
		</div>
	</div>

	<!-- Note about Sunset/Sunrise thresholds -->
	@if (hasDynadimmer && sunsetThresholdHasOneOf && sunriseThresholdHasOneOf) {
		<div class="row note-back-new" id="DSC-note" [ngClass]="{'isResetDisabled': dscDisabled && showEnableFeature}">
			<span class="col-12 note-text signifyBookmd note1MarginSpc"><span class="signifyBoldmd">Note:</span> When using Sunset/Sunrise thresholds to start/stop the Dynadimmer schedule, the mains power to the luminaire should not be switched off during daytime</span>
		</div>
	}

	<!-- Let Light Sensor Control Checkbox -->
	@if (hasDynadimmer && sunsetThresholdHasOneOf && sunriseThresholdHasOneOf) {
		<div class="row slider-container checkbox-indent" [ngClass]="{'isResetDisabled': dscDisabled && showEnableFeature}">
			<!-- <div class="col-1"></div> -->
			<div class="col-10 light-sensor-container" style="margin-left: -1.5em; margin-top: 1em;">
				<label class="checkbox-label" for="DSC-light-sensor">
					<span class="signifyBookmd light-sensor-text">Let light sensor start and stop the Dynadimmer schedule</span>
					<input
						type="checkbox"
						class="primary-checkbox"
						[checked]="letLightSensorControl"
						(change)="onLightSensorCheckboxChange($event)"
						[disabled]="dscDisabled && showEnableFeature"
						id="DSC-light-sensor"
					/>
					<span class="extra-border-enablefeat" id="DSC-light-sensor-checkbox"></span>
				</label>
			</div>
		</div>
	}

	<!-- Sunset Threshold -->
	@if (hasDynadimmer && sunsetThresholdHasOneOf && sunriseThresholdHasOneOf) {
	<div class="row slider-container" [ngClass]="{'isResetDisabled': dscDisabled && showEnableFeature}">
		<div class="col-1 label label-wrap signifyBookmd dim-margin" id="DSC-sunset-threshold-label">Sunset threshold</div>
		@if (quickConfigvalue) {
			<div class="col-2">
				<div class="row">
					<div class="col-4"></div>
					<div class="col-2 minValMargin">
						<span class="signifyBookmd minValue" id="DSC-sunset-threshold-STDmin" [ngClass]="{'isResetDisabled': !letLightSensorControl}"> min {{ sunsetThresholdMin }}</span>
					</div>
					<div class="col-3">
						<span class="signifyBookmd maxValue" id="DSC-sunset-threshold-STDmax" [ngClass]="{'isResetDisabled': !letLightSensorControl}"> max {{ sunsetThresholdMax }}</span>
					</div>
				</div>
			</div>
		}
		@if (!quickConfigvalue) {
			<span class="signifyBookmd text-mindim sliderMinValue col-1" id="DSC-sunset-threshold-min" [ngClass]="{'isResetDisabled': !letLightSensorControl}">{{ sunsetThresholdMin }}</span>
		}
		@if (!quickConfigvalue) {
			<div class="col-6 curvePadding sliderCss" id="DSC-sunset-threshold-slider" [ngClass]="{'isSliderClick': (dscDisabled && showEnableFeature) || !letLightSensorControl, 'isResetDisabled': (dscDisabled && showEnableFeature) || !letLightSensorControl}">
				<ngx-slider
					type="normalType"
					ngDefaultControl
					id="DSC-sunset-threshold-range"
					[value]="getSliderSafeValue(sunsetThreshold, sunsetThresholdMin, sunsetThresholdMax)"
					[options]="sunsetThresholdOptions"
					[disabled]="!letLightSensorControl"
					(userChangeEnd)="onSliderChange($any($event).value, 'sunsetThreshold')"
				>
				</ngx-slider>
			</div>
		}
		@if (!quickConfigvalue) {
			<span class="signifyBookmd text-mindim col-1 startUpMargin" id="DSC-sunset-threshold-max" [ngClass]="{'isResetDisabled': !letLightSensorControl}">{{ sunsetThresholdMax }}</span>
		}
		<div class="row form-group col-3">
			<input
				type="number"
				[value]="letLightSensorControl ? sunsetThresholdDisplay : ''"
				class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
				[ngClass]="{'isResetDisabled custom-inputbox-disabled': !letLightSensorControl, 'myStyle': inputError['sunsetThreshold'], 'inputCssStandard': quickConfigvalue === true}"
				[disabled]="(dscDisabled && showEnableFeature) || !letLightSensorControl"
				(keypress)="numberOnly($event)"
				(input)="onFieldInput($any($event.target).value, 'sunsetThreshold')"
				(blur)="onFieldBlur($any($event.target), 'sunsetThreshold')"
				id="DSC-sunset-threshold-input"
			/>
		</div>
	</div>
	}

	<!-- Sunrise Threshold -->
	@if (hasDynadimmer && sunsetThresholdHasOneOf && sunriseThresholdHasOneOf) {
	<div class="row slider-container" [ngClass]="{'isResetDisabled': dscDisabled && showEnableFeature}">
		<div class="col-1 label label-wrap signifyBookmd dim-margin" id="DSC-sunrise-threshold-label">Sunrise threshold</div>
		@if (quickConfigvalue) {
			<div class="col-2">
				<div class="row">
					<div class="col-4"></div>
					<div class="col-2 minValMargin">
						<span class="signifyBookmd minValue" id="DSC-sunrise-threshold-STDmin" [ngClass]="{'isResetDisabled': !letLightSensorControl}"> min {{ sunriseThresholdMin }}</span>
					</div>
					<div class="col-3">
						<span class="signifyBookmd maxValue" id="DSC-sunrise-threshold-STDmax" [ngClass]="{'isResetDisabled': !letLightSensorControl}"> max {{ sunriseThresholdMax }}</span>
					</div>
				</div>
			</div>
		}
		@if (!quickConfigvalue) {
			<span class="signifyBookmd text-mindim sliderMinValue col-1" id="DSC-sunrise-threshold-min" [ngClass]="{'isResetDisabled': !letLightSensorControl}">{{ sunriseThresholdMin }}</span>
		}
		@if (!quickConfigvalue) {
			<div class="col-6 curvePadding sliderCss" id="DSC-sunrise-threshold-slider" [ngClass]="{'isSliderClick': (dscDisabled && showEnableFeature) || !letLightSensorControl, 'isResetDisabled': (dscDisabled && showEnableFeature) || !letLightSensorControl}">
				<ngx-slider
					type="normalType"
					ngDefaultControl
					id="DSC-sunrise-threshold-range"
					[value]="getSliderSafeValue(sunriseThreshold, sunriseThresholdMin, sunriseThresholdMax)"
					[options]="sunriseThresholdOptions"
					[disabled]="!letLightSensorControl"
					(userChangeEnd)="onSliderChange($any($event).value, 'sunriseThreshold')"
				>
				</ngx-slider>
			</div>
		}
		@if (!quickConfigvalue) {
			<span class="signifyBookmd text-mindim col-1 startUpMargin" id="DSC-sunrise-threshold-max" [ngClass]="{'isResetDisabled': !letLightSensorControl}">{{ sunriseThresholdMax }}</span>
		}
		<div class="row form-group col-3">
			<input
				type="number"
				[value]="letLightSensorControl ? sunriseThresholdDisplay : ''"
				class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
				[ngClass]="{'isResetDisabled custom-inputbox-disabled': !letLightSensorControl, 'myStyle': inputError['sunriseThreshold'], 'inputCssStandard': quickConfigvalue === true}"
				[disabled]="(dscDisabled && showEnableFeature) || !letLightSensorControl"
				(keypress)="numberOnly($event)"
				(input)="onFieldInput($any($event.target).value, 'sunriseThreshold')"
				(blur)="onFieldBlur($any($event.target), 'sunriseThreshold')"
				id="DSC-sunrise-threshold-input"
			/>
		</div>
	</div>}